import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';
import './style.css';

interface IProps {
  children: ReactNode;
  level?: 'sub' | 'section';
  className?: string;
  style?: React.CSSProperties;
}

const Header = ({
  children,
  level = 'sub',
  className,
  ...props
}: IProps): ReactElement => {
  const headerClasses = classNames('header', {
    [`header--${level}`]: level,
    [`${className}`]: className,
  });

  let HeaderEl;

  switch (level) {
    case 'sub':
      HeaderEl = (
        <h4 className={headerClasses} {...props}>
          {children}
        </h4>
      );
      break;
    case 'section':
      HeaderEl = (
        <h5 className={headerClasses} {...props}>
          {children}
        </h5>
      );
      break;
  }

  return HeaderEl;
};

export default Header;
